import { render } from "./Ricevute.vue?vue&type=template&id=55502c02"
import script from "./Ricevute.vue?vue&type=script&lang=js"
export * from "./Ricevute.vue?vue&type=script&lang=js"
script.render = render

export default script